type Platform = 'facebook' | 'twitter' | 'email' | 'whatsapp' | 'url';
type UTMSource = 'unknown' | 'Facebook' | 'E-Mail' | 'WhatsApp' | 'Link' | 'Twitter';

function getSharedUrl(url: string, utmSource: string) {
	const sharedUrl = new URL(url);
	sharedUrl.searchParams.set('UTM_Name', 'Web-Share');
	sharedUrl.searchParams.set('UTM_Medium', 'Link');
	sharedUrl.searchParams.set('UTM_Source', utmSource);

	return sharedUrl.toString();
}

const foundOnBRString = 'via BR24';
const emailFoundOnBRString = 'Via BR24';
const twitterFoundOnBRString = 'via @BR24';

/**
 * Create a sharing link for different platforms.
 *
 * @param target target platform
 * @param body body text of the share message
 * @param utmSource  body text of the share message
 * @param url shareUrl, defaults to window.location.href
 * @returns a url that shares the url on the specified platform
 */
export function createShareUrl(
	target: Platform,
	body?: string,
	utmSource: UTMSource = 'unknown',
	url = globalThis?.location?.href
): `${string}:${string}` {
	let sharingUrl: URL;
	const sharedUrl = getSharedUrl(url, utmSource);

	switch (target) {
		case 'facebook':
			sharingUrl = new URL('https://www.facebook.com/sharer.php');
			sharingUrl.searchParams.set('u', sharedUrl);
			break;

		case 'twitter':
			sharingUrl = new URL('https://twitter.com/intent/tweet');
			if (body) {
				sharingUrl.searchParams.set('text', `${body} | ${twitterFoundOnBRString}\n\n${sharedUrl}`);
			} else {
				sharingUrl.searchParams.set('text', sharedUrl);
			}
			break;

		case 'email':
			sharingUrl = new URL('mailto:');
			if (body) {
				sharingUrl.searchParams.set('subject', `${emailFoundOnBRString}: ${body} `);
				sharingUrl.searchParams.set('body', `${body} | ${foundOnBRString}\n\n${sharedUrl}`);
			} else {
				sharingUrl.searchParams.set('subject', emailFoundOnBRString);
				sharingUrl.searchParams.set('body', sharedUrl);
			}
			break;

		case 'whatsapp':
			sharingUrl = new URL('https://api.whatsapp.com/send');
			if (body) {
				sharingUrl.searchParams.set('text', `${body} | ${foundOnBRString} | ${sharedUrl}`);
			} else {
				sharingUrl.searchParams.set('text', `${foundOnBRString} | ${sharedUrl}`);
			}
			break;

		case 'url':
			sharingUrl = new URL(sharedUrl);
			break;

		default:
			throw new Error('Not platform specified.');
	}

	if (target === 'email') {
		return sharingUrl.toString().replaceAll(/\+/g, '%20') as `${string}:${string}`;
	} else {
		return sharingUrl.toString() as `${string}:${string}`;
	}
}
